import { VOUCHER_DEMO_ACCOUNT_NAME, VOUCHER_DEMO_CAMPUS_ID, VOUCHER_DEMO_CLIENT_ID, VOUCHER_DEMO_MACHINE_ID, VOUCHER_DEMO_MACHINE_NAME } from './voucher-demo.constants';
export var VOUCHER_DEMO_DRINKS_LAST_30D = 412;
export var VOUCHER_DEMO_DRINKS_PCT_CHANGE = 6.4;
function pad2(value) {
    return value < 10 ? '0' + value : String(value);
}
function toYmd(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
}
function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}
function mondayOfWeek(date) {
    var monday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffToMonday = (monday.getDay() + 6) % 7;
    monday.setDate(monday.getDate() - diffToMonday);
    return monday;
}
function parseYmd(value, fallback) {
    var match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    if (!match) {
        return fallback;
    }
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}
function weekdayUnits(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) {
        return 6 + (day === 0 ? 1 : 0);
    }
    if (day === 2 || day === 3) {
        return 18;
    }
    if (day === 1 || day === 4) {
        return 15;
    }
    return 12;
}
export function buildDemoDrinksPeriod() {
    return {
        drinksLast30d: VOUCHER_DEMO_DRINKS_LAST_30D,
        pctChangeLast30d: VOUCHER_DEMO_DRINKS_PCT_CHANGE
    };
}
export function buildDemoSustainability() {
    return { podsSaved: VOUCHER_DEMO_DRINKS_LAST_30D };
}
export function buildDemoTopDrinkTypes() {
    return {
        drinks: [
            { id: 'latte', name: 'Latte', drinksServed: 128 },
            { id: 'americano', name: 'Americano', drinksServed: 96 },
            { id: 'cappuccino', name: 'Cappuccino', drinksServed: 72 },
            { id: 'mocha', name: 'Mocha', drinksServed: 54 },
            { id: 'espresso', name: 'Espresso', drinksServed: 38 },
            { id: 'cold-brew', name: 'Cold Brew', drinksServed: 24 }
        ]
    };
}
export function buildDemoDemandHeatmap(now) {
    if (now === void 0) { now = new Date(); }
    var currentMonday = mondayOfWeek(now);
    var todayIndex = (now.getDay() + 6) % 7;
    var weeks = [];
    var weekdayBoost = [0.7, 1.0, 1.15, 1.15, 1.0, 0.55, 0.45];
    var _loop_1 = function (weekOffset) {
        var weekStart = addDays(currentMonday, -weekOffset * 7);
        var weeklyScale = 0.9 + (0.05 * (8 - weekOffset));
        var countsByDay = weekdayBoost.map(function (boost, dayIndex) {
            if (weekOffset === 0 && dayIndex > todayIndex) {
                return null;
            }
            return Math.round(14 * boost * weeklyScale);
        });
        weeks.push({
            weekStartISO: new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate()).toISOString(),
            countsByDay: countsByDay
        });
    };
    for (var weekOffset = 0; weekOffset < 8; weekOffset++) {
        _loop_1(weekOffset);
    }
    return { weeks: weeks };
}
export function buildDemoMachineBanners() {
    return {
        machines: [{
                machineId: VOUCHER_DEMO_MACHINE_ID,
                machineName: VOUCHER_DEMO_MACHINE_NAME,
                status: 'assigned',
                assignedAt: '2026-08-12',
                imageUrl: 'assets/demo/pacific-crest-banner.png'
            }]
    };
}
export function buildDemoVoucherActivityLedger(now) {
    if (now === void 0) { now = new Date(); }
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
        events: [
            { type: 'issued', occurred_at: toYmd(addDays(today, -74)), count: 50, pack_id: 9101 },
            { type: 'issued', occurred_at: toYmd(addDays(today, -41)), count: 25, pack_id: 9102 },
            { type: 'issued', occurred_at: toYmd(addDays(today, -18)), count: 1, pack_id: 9103 },
            { type: 'issued', occurred_at: toYmd(addDays(today, -11)), count: 1, pack_id: 9104 },
            { type: 'issued', occurred_at: toYmd(addDays(today, -4)), count: 1, pack_id: 9105 },
            { type: 'redeemed', occurred_at: toYmd(addDays(today, -20)), count: 4, pack_id: null },
            { type: 'redeemed', occurred_at: toYmd(addDays(today, -13)), count: 6, pack_id: null },
            { type: 'redeemed', occurred_at: toYmd(addDays(today, -6)), count: 8, pack_id: null },
            { type: 'redeemed', occurred_at: toYmd(addDays(today, -1)), count: 10, pack_id: null }
        ]
    };
}
export function buildDemoSalesSummary(query, now) {
    if (now === void 0) { now = new Date(); }
    var end = parseYmd(query.end_time, now);
    var start = parseYmd(query.start_time, addDays(end, -29));
    var daily_units = [];
    var txnCount = 0;
    for (var cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate()); cursor.getTime() <= end.getTime(); cursor = addDays(cursor, 1)) {
        var vendingUnits = weekdayUnits(cursor);
        txnCount += vendingUnits;
        daily_units.push({
            date: toYmd(cursor),
            vending_units: vendingUnits,
            haha_units: 0
        });
    }
    var revenueCents = txnCount * 450;
    return {
        scope: {
            client_id: Number(VOUCHER_DEMO_CLIENT_ID),
            campus_id: Number(VOUCHER_DEMO_CAMPUS_ID)
        },
        start_time: query.start_time,
        end_time: query.end_time,
        haha: {
            device_count: 0,
            txn_count: 0,
            refund_txn_count: 0,
            unit_count: 0,
            revenue_cents: 0,
            devices: []
        },
        vending: {
            status: 'stripe_readers',
            machine_count: 1,
            mapped_reader_count: 1,
            txn_count: txnCount,
            refund_txn_count: 0,
            revenue_cents: revenueCents
        },
        purchased: {
            txn_count: 0,
            revenue_cents: 0
        },
        daily_units: daily_units,
        minimum_cents: 170000,
        shortfall_cents: 0,
        quantity: 0
    };
}
export function buildDemoMachines() {
    return [{
            machine_id: VOUCHER_DEMO_MACHINE_ID,
            machine_name: VOUCHER_DEMO_MACHINE_NAME + ' · ' + VOUCHER_DEMO_ACCOUNT_NAME,
            campus_id: Number(VOUCHER_DEMO_CAMPUS_ID),
            serial_no: VOUCHER_DEMO_MACHINE_ID
        }];
}
